export default {
      id: "ic-plan-sensibilisation-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-plan-sensibilisation-usage",
      toString: function () {
        return this.url;
      }
    }